
// src/connects/diary-upload-files.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'

export const mapStateToProps = (state, ownProps)=> {
  return {
    uploadFiles: state.uploadFile[ownProps.componentId],
    uploadVideos: state.uploadVideo[ownProps.componentId],
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    cancelUploadFile: (uploadId)=> dispatch(actions.cancelUploadFile(ownProps.componentId, uploadId)),
    cancelUploadVideo: (uploadId)=> dispatch(actions.cancelUploadVideo(ownProps.componentId,uploadId)),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/diary-upload-files.js